import { render, staticRenderFns } from "./reports.vue?vue&type=template&id=a8ca31f8&scoped=true&"
import script from "./reports.vue?vue&type=script&lang=js&"
export * from "./reports.vue?vue&type=script&lang=js&"
import style0 from "./reports.vue?vue&type=style&index=0&id=a8ca31f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ca31f8",
  null
  
)

export default component.exports